import { GO_HOME } from '../actions/home.types';
import { GO_LEARN_MORE } from '../actions/learnMore.types';
import { GO_LOGIN, GO_LOGOUT } from '../actions/auth.types';
import { VIEW as EMAIL_PREFERENCES_VIEW } from '../actions/emailSettings';
import { VIEW as PLAYER_TRACKING_VIEW } from '../actions/tracking.types';
import * as todo from '../actions/aktaryTechPlaceholder.types';
import { NOT_FOUND } from 'redux-first-router';


const viewNames = {
  [GO_HOME]: 'Home',
  [GO_LOGIN]: 'Login',
  [GO_LOGOUT]: 'Logout',
  [GO_LEARN_MORE]: 'LearnMore',
  [NOT_FOUND]: 'NotFound',
  [EMAIL_PREFERENCES_VIEW]: 'myhuddle/EmailPreferences',
  [PLAYER_TRACKING_VIEW]: 'myhuddle/PlayerTracking',

  // To Do
  // Draft Kit
  [todo.GO_DRAFT_KIT]: 'Draft Kit',
  [todo.GO_RANKINGS]: 'Rankings',
  [todo.GO_SLEEPERS]: 'Sleepers',
  [todo.GO_PLAYER_INJURY_REPORTS]: 'Player Injury Reports',
  [todo.GO_AVERAGE_DRAFT_POSITIONS]: 'Positions',
  [todo.GO_DRAFTING_STRATEGY]: 'Drafting Strategy',
  [todo.GO_TOOLS]: 'Tools',
  [todo.GO_INDIVIDUAL_DEFENSIVE_PLAYERS]: 'Individual Defensive Players',
  [todo.GO_AUCTION_LEAGUES]: 'Auction Leagues',
  // PrimaryNav Items
  // Stats
  [todo.GO_STATS]: 'Stats',
  [todo.GO_GAME_SCANS]: 'Game Scans',
  [todo.GO_TEAM_POSITION_RANKINGS]: 'Team Position Rankings',
  // [todo.GO_TEAM_POSITION_RANK_MATCHUPS]: 'Team Position Rank Matchups',
  // [todo.GO_GAME_STATISTICS_MATCHUPS]: 'Game Statistics Matchups',
  [todo.GO_TEAM_STATISTICS]: 'Team Statistics',
  // Resources
  [todo.GO_RESOURCES]: 'Resources',
  [todo.GO_DEPTH_CHARTS]: 'Depth Charts',
  [todo.GO_NFL_SCHEDULE_GRID]: 'NFL Schedule Grid',
  [todo.GO_NFL_SCHEDULE_WEEKLY_GRID]: 'NFL Schedule Weekly Grid',
  [todo.GO_NFL_FULL_WEEKLY_SCHEDULE]: 'NFL Full Weekly Schedule',
  [todo.GO_NFL_DRAFT]: 'NFL Draft',
  [todo.GO_NFL_CALENDAR]: 'NFL Calendar',
  [todo.GO_NEWSLETTER_SIGNUP]: 'Newsletter Signup',
};

export default viewNames;
export const initialView = viewNames[GO_HOME];



// WEBPACK FOOTER //
// ./src/store/actions/view.types.js